export const DESTINATION_RESORTS_PAGE_SIZE = 25;

export const DESTINATION_RESORTS_LOAD_DISTANCE = 100;

export const DESTINATION_COUNTRIES_PAGE_SIZE = 15;

export const DESTINATION_COUNTRIES_LOAD_DISTANCE = 100;
